/**
 * Web entry — charts use DOM SVG (.web.tsx); no Skia bootstrap needed.
 * Firebase Analytics is idle-loaded from telemetry.web, not here.
 */
import { AppRegistry } from 'react-native';

import App from './App';
import { name as appName } from './app.json';

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
